import { EventPage } from "./OrganizationEvents.styles";
import * as EventServiceApi from "apis/EventServiceApi";
import * as UserServiceApi from "apis/UserServiceApi";
import * as CampaignServiceApi from "apis/CampaignServiceApi";
import * as DonorServiceApi from "apis/DonorServiceApi";
import Navbar from "../../../components/navbar/Navbar";
import OrgBannerInfo from "../OrgBannerInfo/OrgBannerInfo";
import { Outlet } from "react-router-dom";

function OrganizationEvents() {
  const onClick = async () => {
    const campaign = await DonorServiceApi.getCampaignDonorsPOST({
      campaign_short: "beenev",
    });
  };

  return (
    <EventPage>
      <Navbar />
      <OrgBannerInfo />
      <Outlet />
      {/*<OrganizationEventsContainer onClick={onClick}>*/}
      {/*</OrganizationEventsContainer>*/}
    </EventPage>
  );
}

export default OrganizationEvents;
